import cx from "classnames"
import { serviceRequestOrFeedbackAnalytics } from "./analytics"

function FormTabs(props) {
  const { activeTab, label, changeActive } = props

  const handleKeyPress = e => {
    if (e.keyCode === 37 && activeTab === "Feedback") {
      changeActive("Service Request")
      serviceRequestOrFeedbackAnalytics("service request")
      document.getElementById("Service Request-tab").focus()
    } else if (e.keyCode === 39 && activeTab === "Service Request") {
      changeActive("Feedback")
      serviceRequestOrFeedbackAnalytics("feedback")
      document.getElementById("Feedback-tab").focus()
    }
  }

  return (
    <div className="tabs">
      <ul id="contactus-tab-list" className="tab-list" role="tablist">
        {label.map(item => (
          <li
            id={`${item}-tab`}
            role="tab"
            aria-selected={activeTab === item}
            tabIndex={activeTab === item ? 0 : -1}
            className={cx({
              "tab-list-item": true,
              "tab-list-active": activeTab === item,
            })}
            key={item}
            onClick={() => {
              changeActive(item)
            }}
            onKeyDown={e => handleKeyPress(e)}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
export default FormTabs
